// extracted by mini-css-extract-plugin
module.exports = {"logo_footer":"styles_logo_footer__1sqVp","container_footer1":"styles_container_footer1__1nKkm","container_footer2":"styles_container_footer2__3GsBj"};